/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SiteOperationsMapSummaryResponseDto
 */
export interface SiteOperationsMapSummaryResponseDto {
    /**
     * 
     * @type {number}
     * @memberof SiteOperationsMapSummaryResponseDto
     */
    siteCount: number;
    /**
     * 
     * @type {number}
     * @memberof SiteOperationsMapSummaryResponseDto
     */
    zoneCount: number;
    /**
     * 
     * @type {number}
     * @memberof SiteOperationsMapSummaryResponseDto
     */
    totalAssets: number;
    /**
     * 
     * @type {number}
     * @memberof SiteOperationsMapSummaryResponseDto
     */
    healthyAssets: number;
    /**
     * 
     * @type {number}
     * @memberof SiteOperationsMapSummaryResponseDto
     */
    warningAssets: number;
    /**
     * 
     * @type {number}
     * @memberof SiteOperationsMapSummaryResponseDto
     */
    criticalAssets: number;
    /**
     * 
     * @type {number}
     * @memberof SiteOperationsMapSummaryResponseDto
     */
    totalOpenIncidents: number;
}

/**
 * Check if a given object implements the SiteOperationsMapSummaryResponseDto interface.
 */
export function instanceOfSiteOperationsMapSummaryResponseDto(value: object): value is SiteOperationsMapSummaryResponseDto {
    if (!('siteCount' in value) || value['siteCount'] === undefined) return false;
    if (!('zoneCount' in value) || value['zoneCount'] === undefined) return false;
    if (!('totalAssets' in value) || value['totalAssets'] === undefined) return false;
    if (!('healthyAssets' in value) || value['healthyAssets'] === undefined) return false;
    if (!('warningAssets' in value) || value['warningAssets'] === undefined) return false;
    if (!('criticalAssets' in value) || value['criticalAssets'] === undefined) return false;
    if (!('totalOpenIncidents' in value) || value['totalOpenIncidents'] === undefined) return false;
    return true;
}

export function SiteOperationsMapSummaryResponseDtoFromJSON(json: any): SiteOperationsMapSummaryResponseDto {
    return SiteOperationsMapSummaryResponseDtoFromJSONTyped(json, false);
}

export function SiteOperationsMapSummaryResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiteOperationsMapSummaryResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'siteCount': json['siteCount'],
        'zoneCount': json['zoneCount'],
        'totalAssets': json['totalAssets'],
        'healthyAssets': json['healthyAssets'],
        'warningAssets': json['warningAssets'],
        'criticalAssets': json['criticalAssets'],
        'totalOpenIncidents': json['totalOpenIncidents'],
    };
}

export function SiteOperationsMapSummaryResponseDtoToJSON(json: any): SiteOperationsMapSummaryResponseDto {
    return SiteOperationsMapSummaryResponseDtoToJSONTyped(json, false);
}

export function SiteOperationsMapSummaryResponseDtoToJSONTyped(value?: SiteOperationsMapSummaryResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'siteCount': value['siteCount'],
        'zoneCount': value['zoneCount'],
        'totalAssets': value['totalAssets'],
        'healthyAssets': value['healthyAssets'],
        'warningAssets': value['warningAssets'],
        'criticalAssets': value['criticalAssets'],
        'totalOpenIncidents': value['totalOpenIncidents'],
    };
}

